import { render, staticRenderFns } from "./accountRateList.vue?vue&type=template&id=6aa03684&"
import script from "./accountRateList.vue?vue&type=script&lang=js&"
export * from "./accountRateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports